export function filterStart(val) { //评分星级
    let full = val ? val.toString().split('.')[0] : 0;
    let half = 0;
    if (val ? val.toString().split('.')[1] : 0 > 5) {
        full = full * 1 + 1;
    }
    
    let empty = 5 - full;
    let list = [];
    for(let i = 0; i < full; i++){
        list.push(2)
    }
    if (val ? val.toString().split('.')[1] : 0 == 5) {
        list.push(1)
    };
    for(let i = 0; i < empty; i++){
        list.push(0)
    }
    return list
}